import PageShell from "@/components/PageShell";
import { ShieldCheck, Lock, KeyRound, FileCheck2, Fingerprint, ServerCog } from "lucide-react";

const ITEMS = [
  { icon: Lock, t: "Şifreleme & HTTPS", d: "Tüm veriler aktarım sırasında TLS ile şifrelenir. Hassas bilgiler güvenli şekilde saklanır." },
  { icon: Fingerprint, t: "İki Aşamalı Doğrulama (2FA)", d: "Hesabınızı TOTP tabanlı 2FA ile ekstra bir güvenlik katmanıyla koruyun." },
  { icon: KeyRound, t: "Gizli Anahtar Yönetimi", d: "API ve gizli anahtarlar yalnızca sunucu tarafında tutulur, istemciye asla gönderilmez." },
  { icon: FileCheck2, t: "Webhook İmza Doğrulama", d: "Tüm webhook'lar imzalanır ve idempotency ile aynı olayın iki kez işlenmesi engellenir." },
  { icon: ServerCog, t: "Rate Limiting", d: "API ve giriş işlemlerinde hız sınırlaması ile kötüye kullanım önlenir." },
  { icon: ShieldCheck, t: "Audit Logs & RBAC", d: "Rol bazlı erişim kontrolü ve tüm kritik işlemler için denetim kayıtları." },
];

export default function Security() {
  return (
    <PageShell title="Güvenlik" subtitle="Coinbuy, finansal işlemlerinizi production seviyesinde güvenlik önlemleriyle korur.">
      <div className="grid sm:grid-cols-2 gap-5">
        {ITEMS.map((f) => (
          <div key={f.t} className="rounded-2xl border border-border bg-card p-6">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <f.icon size={20} strokeWidth={1.5} />
            </span>
            <h3 className="mt-4 text-base font-bold">{f.t}</h3>
            <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{f.d}</p>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
